import { navStateStore } from "../state/nav-state-store";
import windowService from "./window-service";
import { FeatureMap } from "../state/feature-toggles-state";
import { MicroAgentWrapper, NavigationAgent, NavigationPageAction } from "./micro-agent-wrapper";
import { dequeueError, enqueueError, eventifyErrorQueue, getErrorQueue } from './error-queue.service';

export async function initMicroAgent(): Promise<NavigationAgent | null> {
  return MicroAgentWrapper.init();
}

/**
 * Error handler to enqueue errors
 * Caution: Stencil will not catch errors thrown in async code
 * To capture those, wrap the async code in a try/catch block and use the logger service
 * @param error
 */
export function navigationAgentErrorHandler(err: Error): void {
  enqueueError(err);
}

export function trackNavigationLoad(): void {
  MicroAgentWrapper.addPageAction(NavigationPageAction.NAVIGATION_LOADED, {
    navigationVersion: windowService.version,
  });
}

export function trackNavigationDrawerLoad(): void {
  MicroAgentWrapper.addPageAction(
    NavigationPageAction.NAVIGATION_DRAWER_LOADED,
    {
      navigationVersion: windowService.version,
      drawerVersion: windowService.drawerVersion,
    },
  );
}

export function processErrorQueue(): void {
  const errorQueue = getErrorQueue();

  if (errorQueue) {
    while (errorQueue.length > 0) {
      const processedError = dequeueError();
      if (processedError) {
        captureNaviException(processedError);
      }
    }
  }
}

export function eventifyErrorHandling(): void {
  eventifyErrorQueue(processErrorQueue);
}

export function trackFeatureToggles(features: FeatureMap): void {
  MicroAgentWrapper.addPageAction(NavigationPageAction.NAVIGATION_FEATURES, {
    features,
  });
}

function captureNaviException(
  err: Error
): void {
  MicroAgentWrapper.noticeError(err, {
    tags: {
      navigationVersion: windowService.version || null,
      drawerVersion: windowService.drawerVersion || null,
      env: navStateStore.state.env || null,
    },
  });
}
